import {cardStyle, mergeStyle} from './styles';
import React from 'react';

export default function Card(props) {
    let marginRight = props.left ? "0px" : "20px";
    let marginLeft = props.right ? "0px" : "20px";
    const style = mergeStyle(cardStyle, {
        marginLeft: marginLeft,
        marginRight: marginRight,
    });
    
    return ( 
        <div style={style}>
            {props.children}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Card.jsx